<script setup lang="ts">

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { AppMultiSelect, AppSelect } from '@shared/ui/selects'

import { useFiltersDisciplineBalances } from '../model/filters-discipline-balances.hook'

defineOptions({
  name: 'FiltersDisciplineBalances',
})

const {
  refReasons,
  refResponsible,
  reasonOptions,
  responsibleOptions,
  isLoading,
  canManageBalances,
  search,
  clearFilters,
  openEditBalance,
} = useFiltersDisciplineBalances()
</script>

<template>
  <div class="filters-discipline-balances">
    <div class="filters-discipline-balances__fields">
      <AppMultiSelect
        v-model="refReasons"
        class="filters-discipline-balances__reason"
        :options="reasonOptions"
        label="Reason"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
      <AppSelect
        v-model="refResponsible"
        class="filters-discipline-balances__responsible"
        :options="responsibleOptions"
        label="Responsible"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
      <BtnPrimary
        text="Search"
        :disabled="isLoading"
        @click="search"
      />
      <BtnIcon
        :icon="faFilterCircleXmark"
        color="red"
        tooltip-text="Clear filters"
        :disabled="isLoading"
        @click="clearFilters"
      />
    </div>
    <BtnPrimary
      v-if="canManageBalances"
      text="Edit balance"
      color="emerald"
      @click="openEditBalance"
    />
  </div>
</template>

<style scoped lang="scss" src="./FiltersDisciplineBalances.scss" />
